//  Copyright (c) 2025 coze-dev
//  SPDX-License-Identifier: MIT

// @ts-expect-error no members are exported from this path
export * from '@coze-editor/code-language-typescript/dist/esm/worker.js';
